<template>
  <svg
    :width="iconWidth"
    :height="iconHeight"
    :style="iconStyle"
    :class="['icon', `icon-${name}`]"
    aria-hidden="true"
    focusable="false"
  >
    <use :href="`#${name}`" />
  </svg>
</template>

<script>
/**
 * Auto-generated type definitions for SVG icons
 * Generated on 2025-08-06T23:10:04.534Z
 * 
 * @typedef {'article-two'|'article-wan'|'blog'|'certification-icon'|'chevron-down'|'contact'|'facebook'|'github-filled'|'github'|'happy-client'|'headset'|'help'|'home'|'linkedin'|'logofolio'|'picture'|'reddit'|'share'|'speech-bubble'|'twitter'|'whatsapp'} IconName
 */

export default {
  name: 'Icon',

  props: {
    /**
     * Name of the SVG icon to render from the sprite
     * @type {IconName}
     */
    name: {
      type: String,
      required: true,
      validator: function (value) {
        // This validator will be updated automatically when the sprite is generated
        const validIcons = [
          'article-two', 'article-wan', 'blog', 'certification-icon', 'chevron-down', 'contact', 'facebook', 'github-filled', 'github', 'happy-client', 'headset', 'help', 'home', 'linkedin', 'logofolio', 'picture', 'reddit', 'share', 'speech-bubble', 'twitter', 'whatsapp'
        ];
        return validIcons.includes(value);
      }
    },

    /**
     * Width of the icon
     * @type {String|Number}
     */
    width: {
      type: [String, Number],
      default: 24
    },

    /**
     * Height of the icon
     * @type {String|Number}
     */
    height: {
      type: [String, Number],
      default: 24
    },

    /**
     * Alias for width and height
     * @type {String|Number}
     */
    size: {
      type: [String, Number],
      default: 24
    },

    /**
     * Fill color of the icon
     * @type {String}
     */
    color: {
      type: String,
      default: 'currentColor'
    },
  },

  computed: {
    iconWidth () {
      if (this.size) {
        return typeof this.size === 'number' ? `${this.size}px` : this.size;
      }
      return typeof this.width === 'number' ? `${this.width}px` : this.width;
    },

    iconHeight () {
      if (this.size) {
        return typeof this.size === 'number' ? `${this.size}px` : this.size;
      }
      return typeof this.height === 'number' ? `${this.height}px` : this.height;
    },

    /**
     * Computed style for the icon
     * @returns {Object}
     */
    iconStyle () {
      return {
        width: this.iconWidth,
        height: this.iconHeight,
        fill: this.color
      };
    }
  }
};
</script>

<style scoped>
.icon {
  display: inline-block;
  vertical-align: middle;
}
</style>
